import ReactGA from 'react-ga';
export var Analytics = function () {
    var initializeReactGA = function (GA_UA, DEBUG) {
        if (DEBUG === void 0) { DEBUG = true; }
        if (GA_UA)
            ReactGA.initialize(GA_UA, { debug: DEBUG });
    };
    var setUser = function (userId) { return ReactGA.set({ userId: userId }); };
    var pageview = function (pageName) { return ReactGA.pageview(pageName); };
    var trackEvent = function (category, action, value, label) {
        var event = { category: category, action: action };
        if (value !== null && event !== undefined)
            event['value'] = value;
        if (label !== null && label !== undefined)
            event['label'] = value;
        ReactGA.event(event);
    };
    return {
        initializeReactGA: initializeReactGA,
        pageview: pageview,
        trackEvent: trackEvent,
        setUser: setUser
    };
};
//# sourceMappingURL=Analytics.js.map